/** A job occupies whole diary slots on the branch grid. */
export function occupiedMinutes(durationMinutes, intervalMinutes) {
  const step = intervalMinutes < 15 ? 15 : intervalMinutes;
  const work = durationMinutes < 1 ? step : durationMinutes;
  return Math.ceil(work / step) * step;
}
